import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  HrFlexContainer,
  HrTitleContainer,
  HrTitleH4,
  HrButtons,
  HrParagraph,
  HrFontBold
} from '@components/styles/hr-styles';
import { HrButton } from '@components/button/button';
import { Modal } from '../../../postulation_form/components/modal';

export const DeleteRequestModal = ({ actualRowId, delete1, setShowModalDeleteRequest }) => {
  const [t] = useTranslation();

  const handleDeleteRequest = () => {
    delete1.mutate({ idRequisition: actualRowId });
  };

  return (
    <Modal setShowModal={setShowModalDeleteRequest}>
      <HrTitleContainer padding='32px 32px 12px 32px' gap='4px'>
        <i className='hr-Trash' style={{ fontSize: '20px' }} />
        <HrTitleH4>{t('requestVacancies.colaborativeSelection.modal.deleteRequest.title')}</HrTitleH4>
      </HrTitleContainer>
      <HrFlexContainer padding='16px 32px 0 32px' gap='8px'>
        <HrParagraph fontWeight={HrFontBold}>
          {t('requestVacancies.colaborativeSelection.modal.deleteRequest.subTitle')}
        </HrParagraph>
        <HrParagraph>{t('requestVacancies.colaborativeSelection.modal.deleteRequest.clarification')}</HrParagraph>
      </HrFlexContainer>
      <HrFlexContainer padding='32px' justifyContent='flex-end' gap='8px'>
        <HrButtons
          type='button'
          category='cancel'
          size='medium'
          onClick={() => {
            setShowModalDeleteRequest(false);
          }}
        >
          {t('general.button.close')}
        </HrButtons>
        <HrButton
          type='button'
          category='secondary'
          size='medium'
          onClick={handleDeleteRequest}
          loading={delete1.isLoading}
          disabled={delete1.isLoading}
          text={t('general.button.delete')}
          name='delete'
        />
      </HrFlexContainer>
    </Modal>
  );
};
